import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateVaultDialogComponent } from 'app/dialogs/create-vault-dialog/create-vault-dialog.component';
import { CreateVaultMovementComponent } from 'app/dialogs/create-vault-movement/create-vault-movement.component';
import { AuthService } from 'app/services/auth.service';
import { VaultService } from 'app/services/models/vault.service';
import feather from 'feather-icons';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-vault-detail',
  templateUrl: './vault-detail.component.html',
  styleUrls: ['./vault-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VaultDetailComponent implements OnInit {
  public contentHeader = null;
  @BlockUI('section-block') blockUI: NgBlockUI;

  vault = null;
  constructor(
    private activadetRouter: ActivatedRoute,
    private modalService: NgbModal,
    private vaultService: VaultService,
    private router:Router,
    private authService:AuthService) { }

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'Hesaplarım',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Hesap Detayı ve Hareketleri',
            isLink: false,
          },
        ]
      }
    }
    this.vaultService.event$.subscribe(result => {
      this.activadetRouter.params.subscribe(async params => {
        await this.getByIdVault(params['id']);
      })
    })
    this.activadetRouter.params.subscribe(async params => {
      await this.getByIdVault(params['id']);
    });
    feather.replace();
  }

  toggleExpand(item: any) {
    item.isExpanded = !item.isExpanded;
  }

  async getByIdVault(id) {
    this.blockUI.start("Hesap bilgileri yükleniyor...")
    const vaultDetailAuthorization = this.authService.isEndpointStatus('GET.Reading.GetByIdVault');
    if(vaultDetailAuthorization){
      const data = await this.vaultService.getByIdVault(id);
      data.companyVaultMovements.forEach(item => item.isExpanded = false);
      data.vaultVaultMovements.forEach(item => item.isExpanded = false);
      this.vault = data;
      console.log(this.vault);  
    }
    this.blockUI.stop();
  }

  showDetail(data) {
    const modal = this.modalService.open(CreateVaultDialogComponent, {
      size: 'ml',
      centered: true,
      windowClass: 'modal modal-success'
    })
    modal.componentInstance.data = {
      id: data.id,
      title: data.title,
      description: data.description,
      kindId: data.kindId
    };
  }

  showCreateMovement(vaultId, number) {
    const modal = this.modalService.open(CreateVaultMovementComponent, {
      size: 'ml',
      centered: true,
      windowClass: 'modal modal-success'
    })
    modal.componentInstance.data = {
      vaultId: vaultId,
      number: number
    };
  }
}
